import { PLACEHOLDER } from '../RecentSoldPrices/RecentSoldPrices.consts';
import RecentSoldPricesTexts from '../RecentSoldPrices/RecentSoldPrices.texts';

export default {
	...RecentSoldPricesTexts,
	columns: {
		mileage: 'Mileage',
		regYear: 'Reg year',
		serviceHistory: 'Service history',
		soldDate: 'Sold date',
		soldPrice: 'Sold price',
		vehicle: 'Vehicle',
	},
	serviceHistory: {
		full: 'Full',
		no: 'None',
		not_applicable: 'Not yet due',
		partial: 'Partial',
		skipped: PLACEHOLDER,
		yes: 'Available',
	},
};
